import { FC } from 'react';
import AppExtension from '../AppExtension';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(
    () => ({
        layout: {
            height: 'calc(100vh - 180px)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'stretch',
        },
    }),
    { classNamePrefix: 'app-extension-main-nav' }
);

const AppExtensionMainNav: FC = () => {
    const classes = useStyles();
    const { extensionId } = useParams();

    return (
        <div className={classes.layout}>
            <AppExtension extensionId={extensionId} />
        </div>
    );
};

export default AppExtensionMainNav;
